"use client";

import { Skeleton } from "@/app/ui/atomic/animations";
import { createLazyComponent } from "@/app/ui/molecular/createLazyComponent";

const Timeline = createLazyComponent(
  () => import("@/app/ui/molecular/Timeline"),
  {
    skeleton: {
      type: "custom",
      render: () => (
        <div className="w-full py-8">
          <div className="flex gap-4 overflow-hidden px-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex-shrink-0 w-28 text-center">
                <Skeleton variant="circular" width={48} height={48} className="mx-auto mb-2" />
                <Skeleton variant="text" width="80%" className="mx-auto" />
              </div>
            ))}
          </div>
        </div>
      ),
    },
  }
);

export default Timeline;
